<template>
  <div
    v-if="topFocused"
    class="overlay-wrap top-highlight-overlay"
    @click="closeTopFocus"
  />
  <div class="top-section" :class="{ 'top-section--focused': topFocused }" ref="topSectionRef">
    <div class="cardMember">
      <MemberCard
        :hasLoad="hasLoad"
        :profile="$store.state.profile"
        :profilePic="profilePic"
        @update-profile="goToProfileUpdate"
        @show-card="showthecard"
      />
    </div>
    <BenefitAnggotaCard :benefit="benefit" />
  </div>
  <div class="dashboard-container mt-2 mb-2">
    <div class="dashboard-left">
      <div class="dashboard-card">
        <MembershipInfoCard
          @click-documents="$router.push('/dashboard/dokumen')"
          @click-aspirasi="$router.push('/dashboard/aspirasi')"
          @click-laporan="$router.push('/dashboard/laporan-kegiatan')"
        />
      </div>

      <ConnectAccountCard>
        <MotionBank />
        <MotionPay />
      </ConnectAccountCard>
    </div>

    <div class="dashboard-right">
      <NewAgenda
        @dateselected="getTodayEvent"
        @eventselected="getEventClicked"
        :loading="isEventLoading"
        :list="todayEvent"
        type="home"
      />
    </div>
  </div>

  <div style="padding: 16px; border-radius: 16px; background: white;">
    <div class="event-wrapper">
      <div v-if="showDefaultEvent" class="slider">
        <div class="flex justify-content-between">
          <div class="text-bold mb-1 text-heading">
            Event Mendatang
          </div>
          <div
            v-if="listEventFuture.length > 0"
            class="lihat pointer text-bold"
            @click="seeAllAgenda()"
          >
            Lihat Semua
          </div>
        </div>
        <slider v-if="listEventFuture.length > 0" :dataslide="listEventFuture"></slider>
        <h5 class="ml-2 mb-3" v-if="listEventFuture.length === 0">Belum ada event</h5>
      </div>
    </div>
  </div>

  <div style="padding: 16px; border-radius: 16px; background: white; margin-top: 32px;">
    <div class="event-wrapper">
      <div v-if="showDefaultEvent" class="slider">
        <div class="flex justify-content-between">
          <div class="text-bold mb-1 text-heading">
            Event Sebelumnya
          </div>
          <div
            v-if="listEventPast.length > 0"
            class="lihat pointer text-bold"
            @click="seeAllAgenda()"
          >
            Lihat Semua
          </div>
        </div>
        <slider v-if="listEventPast.length > 0" :dataslide="listEventPast"></slider>
        <h5 class="ml-2 mb-3" v-if="listEventPast.length === 0">Belum ada event</h5>
      </div>
    </div>
  </div>

  <splash v-if="showSplash && !hasLoad"></splash>
</template>
<style lang="scss">
.event-wrapper {
  padding: 12px !important;
  border-radius: 16px;
  margin-top: 32px;
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #f5f8ff 100%
  );
}

.top-highlight-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99998;
  opacity: 1 !important;
  visibility: visible !important;
}

.top-section--focused {
  position: relative;
  z-index: 99999;

  border-radius: 16px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
}

.top-section--focused {
  position: relative;
  z-index: 99999;
  border-radius: 16px;
}

.top-section--focused::before {
  content: "";
  position: absolute;
  inset: -16px;
  border-radius: 20px;
  pointer-events: none;
  z-index: -1;
  background-color: #f5f5f5;
}

.to-download {
  width: 523px !important;
  // @media (min-width: 768px) {
  //   width: 300px !important;
  // }
  @font-face {
    font-family: "Gotham Book";
    src: url("/fonts/Gotham-Book.otf") format("opentype");
  }

  @font-face {
    font-family: "Gotham Medium";
    src: local("Gotham-Medium") url("/fonts/Gotham-Medium.otf")
      format("opentype");
  }
  @font-face {
    font-family: "Gotham Bold";
    src: url(/fonts/GothamBold.ttf) format("truetype");
  }

  @media only screen and (max-width: 600px) {
  }

  .flip-card {
    aspect-ratio: initial;
  }

  .flip-card-front,
  .flip-card-back {
    margin-bottom: 1rem;
    height: 300px !important;
  }

  .flip-card-back {
    border-top: 1px solid #c2c2c2;
  }

  .flip-card .cardWrap {
    padding-top: 0;
    // height: 640px;
    height: 660px;
    .flip-card-front {
      font-family: "Gotham Medium", sans-serif;
      border-bottom: 1px solid #c2c2c2;
      margin-bottom: 40px;

      .cardData {
        .header {
          display: flex;
          justify-content: center;
          width: 100% !important;
          .logo {
            width: 90px;
            // @media screen and (min-width: 320px) and (max-width: 480px) {
            //   width: 60px;
            // }
            // @media (min-width: 481px) and (max-width: 767px) {
            //   width: 72px;
            // }
          }
        }
        .title {
          background: linear-gradient(to right, #1d3b82 20%, #9b2f5d 70%, #d1272d 100%);
          // padding: 8px 0;
          padding: 12px 0;
          // @media screen and (min-width: 320px) and (max-width: 767px) {
          //   padding: 8px 0;
          // }
          p {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 0;
            color: #ffffff;
            text-align: center;
          }
          h1 {
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
          }
          img {
            margin: 0 auto;
            width: 290px;
          }
        }
        .content {
          display: flex;
          justify-content: space-between;
          padding: 15px 14px 15px 20px;
          .photo {
            background-color: #000000;
            height: 100%;
            // width: max-content;
            // height: 95px;
            width: 90px;
            height: 83px;
            display: flex;
            padding: 5px 1px 1px 1px;
            margin-bottom: .5rem;
            margin-right: 8px;
            justify-content: center;
            @media screen and (min-width: 320px) and (max-width: 767px) {
              width: 83px;
              height: 83px;
            }
            @media (min-width: 768px) and (max-width: 1024px) {
              // width: 90px;
              // height: 90px;
              // width: 70px;
              // height: 70px;
              width: 85px;
              height: 85px;
            }
            img {
              object-fit: cover;
            }
          }
          .qrcode {
            width: 70px;
            height: 70px;
            @media screen and (min-width: 320px) and (max-width: 767px) {
              width: 90px;
              height: 90px;
            }
            @media screen and (min-width: 768px) {
              width: 90px;
              height: 90px;
            }
          }
        }

        .profile-wrapper {
          width: 85px;
          font-family: "Gotham Bold";
          .supersmall {
            font-size: 10px;
            letter-spacing: 0.6px;
          }
          h3 {
            line-height: 0.5;
            font-size: 16px;
          }
        }

        .nik {
          font-size: 18px;
          margin-top: .7rem;
        }

        .name {
          font-size: 16px;
          font-weight: 400;
          margin-top: 0.3rem;
          display: flex;
          flex-direction: column;
          line-height: 1.2rem;
          width: 90%;
          text-transform: capitalize;
          font-family: "Gotham Bold";
          p {
            margin-bottom: 0;
          }
        }

        .bod {
          font-size: 12px;
          font-weight: 400;
          font-family: 'Gotham Book';
          line-height: 13px;
          font-weight: 400;
          width: 83%;
          margin-bottom: 4px;
        }

        .addressWrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 300px;
          font-size: 12px;
          font-family: "Gotham Book";
          .address {
            // width: 90%;
            width: 83%;
            font-size: 12px;
            line-height: 13px;
            font-weight: 400;
            text-transform: capitalize;
          }
        }
        .phone {
          margin-top: 10px;
          font-size: 12px;
          font-family: 'Gotham Book';
        }

        h3 {
          font-size: 16px;
          font-family: "Gotham Bold";
        }
      }
    }

    .flip-card-back {
      transform: initial !important;
      top: 340px;
    }
  }
}
</style>

<style lang="scss" scoped>

.image-holder-kta {
  margin-right: 0.5rem;
  height: 80px !important;
  min-width: 71px !important;
  max-width: 71px !important;
  img {
    background-color: #c0c0c0;
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}
.top-section {
  display: grid;
  grid-template-columns: minmax(0, 560px) 1fr;
  grid-gap: 2rem;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  .cardMember {
    width: 100% !important;

    @media only screen and (max-width: 1024px) {
      width: 400px;
      min-width: 0 !important;
    }

    .cardDetail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .detail {
        padding: 1rem;

        .data {
          display: grid;
          grid-template-columns: 1fr;
          grid-gap: 1rem;

          .detailCard {
            .name {
              margin-bottom: 10px;
            }
          }
        }

        button {
          padding: 10px;
        }
      }

      .button-group-dokumen {
        .little {
          padding: 15px 0;
        }
      }
    }
  }
}
.lihat {
  color: #243E81;
}

.overlay-wrap {
  opacity: 0;
  visibility: hidden;

  .cardMemberOfficial {
    transform: scale(0.5);
    transition: all ease 0.7s;

    .two-grid {
      margin: 3rem auto 0 auto;

      @media only screen and (max-width: 600px) {
        display: block;
      }
      @media (min-width: 481px) and (max-width: 767px) {
        grid-template-columns: 1fr;
      }

      .btn-fill {
        padding: 10px 1rem;

        @media only screen and (max-width: 600px) {
          margin-bottom: 10px;
          width: 100%;
          height: 40px;
        }
      }

      .btn-img {
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $blue;

        img {
          margin-right: 10px;
        }
      }
    }

    .btn-close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: none;
      margin-left: 100%;
      margin-bottom: 14px;
      @media screen and (min-width: 320px) and (max-width: 480px) {
        margin-left: 91%;
      }
      @media (min-width: 481px) and (max-width: 767px) {
        margin-left: 92%;
      }
    }

    &.directDownload {
      transform: unset;
    }
  }

  &.active {
    opacity: 1;
    visibility: visible;

    .cardMemberOfficial {
      transform: scale(1);
    }
  }
}

.directDownload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.document-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  z-index: 101;
}

.document-index {
  z-index: 99999;
}

.document-tooltips {
  margin-top: 1rem;
    position: absolute;
    display: flex;
    background-color: #21409a;
    padding: 0.5rem 1.2rem;
    color: #fff;
    border-radius: 1rem;
    z-index: 101;
    left: 0;
    top: 105%;
    width: max-content;

  .arrow {
    position: absolute;
    width: 20px;
    height: 20px;
    top: -2px;
    content: "";
    background-color: $blue;
    transform: rotate(45deg);
    z-index: -1;
  }

  svg {
    margin-top: 0.2rem;
  }

  span {
    font-weight: 600;
    align-self: center;
    margin-left: 0.4rem;
  }
}

.card-dokumen {
  max-width: 130px;
  padding: 1rem;
  position: relative;
}

.connect-wallet {
  margin-top: .8rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.dashboard-container {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 16px;
  width: 100%;
  align-items: start;
}

.dashboard-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dashboard-right {
  width: 100%;
}

.dashboard-card {
  width: 100%;
  display: grid;
  gap: 8px;
}
.dashboard-card > * {
  flex: 1;
}

@media (max-width: 1024px) {
  .dashboard-container {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import domtoimage from 'dom-to-image-more'
import slider from '../../components/cardSlider.vue'
import MotionBank from '../../components/Wallet/MotionBank.vue'
import MotionPay from '../../components/Wallet/MotionPay.vue'
import splash from '../../components/splash.vue'
import axios from 'axios'
import NewAgenda from './NewAgenda.vue'
import MemberCard from '../../components/MemberCard.vue'
import BenefitAnggotaCard from '../../components/BenefitAnggotaCard.vue'
import MembershipInfoCard from '../../components/MembershipInfoCard.vue'
import ConnectAccountCard from '../../components/ConnectAccountCard.vue'

export default {
  data () {
    return {
      isShowExisting: false,
      download_count: 0,
      dateNow: new Date(),
      notMember: false,
      showCard: false,
      showCardPolls: false,
      profile: null,
      showSplash: false,
      showDefaultEvent: true,
      hasLoad: false,
      showDownload: false,
      isFlip: false,
      listEvent: [],
      listEventNow: [],
      listEventPast: [],
      listEventFuture: [],
      listPolling: [],
      todayEvent: [],
      isEventLoading: false,
      profilePic: null,
      isDownloading: false,
      tempDate: new Date(),
      benefit: null,

      topFocused: false
    }
  },
  async mounted () {
    document.title = 'Dashboard - Home'
    this.showSplash = true
    try {
      await this.$store.dispatch('getProfile')
      const profile = this.$store.getters.getProfile

      if (profile) {
        await this.$store.commit('setDocumentHighlight', true)
        const doc = document.getElementById('card-dokumen')
        if (doc) doc.scrollIntoView({ behavior: 'smooth' })
        setTimeout(() => {
          this.$store.commit('setDocumentHighlight', false)
        }, 10000)

        this.topFocused = false
        this.$store.commit('setCardIsShow', false)
      } else {
        this.topFocused = true
        this.$store.commit('setCardIsShow', true)

        this.$nextTick(() => {
          const el = this.$refs.topSectionRef
          if (el?.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        })
      }
    } catch (err) {
      this.logger('no profile found')

      this.topFocused = true
      this.$store.commit('setCardIsShow', true)

      this.$nextTick(() => {
        const el = this.$refs.topSectionRef
        if (el?.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    }
    this.getListEvent()
    this.getListEventFuture()
    this.getListEventPast()
    this.getListPolling()
    this.showSplash = false
    this.getMemberBenefit()
    this.hasLoad = true
  },
  components: {
    slider,
    splash,
    MotionBank,
    MotionPay,
    NewAgenda,
    MemberCard,
    BenefitAnggotaCard,
    MembershipInfoCard,
    ConnectAccountCard
  },
  computed: {
    isCardPollsShow () {
      return this.$store.getters.getStatePollsCard
    },
    showDocumentHighlight () {
      return this.$store.getters.getDocumentHighlight
    }
  },
  methods: {
    closeTopFocus () {
      this.topFocused = false
      this.$store.commit('setCardIsShow', false)

      // behavior lama: highlight dokumen lalu scroll (kalau masih kamu mau)
      this.$store.commit('setDocumentHighlight', true)
      const doc = document.getElementById('card-dokumen')
      if (doc) doc.scrollIntoView({ behavior: 'smooth' })

      setTimeout(() => {
        this.$store.commit('setDocumentHighlight', false)
      }, 10000)
    },
    goToProfileUpdate () {
      this.$router.push('/dashboard/profil?ref=updateprofil')
    },
    async getListEvent () {
      const params = {
        cache: true,
        limit: 10,
        page: 1,
        timeline: 'now'
      }
      const {
        data: { data }
      } = await axios.get('content/listevent', {
        params,
        transformRequest: (data, headers) => {
          delete headers.Authorization
        }
      })
      this.listEventNow = data
    },
    async getListEventFuture () {
      const params = {
        cache: true,
        limit: 10,
        page: 1,
        timeline: 'future'
      }
      const {
        data: { data }
      } = await axios.get('content/listevent', {
        params,
        transformRequest: (data, headers) => {
          delete headers.Authorization
        }
      })
      this.listEventFuture = data
    },
    async getListEventPast () {
      const params = {
        cache: true,
        limit: 10,
        page: 1,
        timeline: 'past'
      }
      const {
        data: { data }
      } = await axios.get('content/listevent', {
        params,
        transformRequest: (data, headers) => {
          delete headers.Authorization
        }
      })
      this.listEventPast = data
    },
    async getListPolling () {
      const params = {
        limit: 10,
        page: 1
      }
      const {
        data: { data }
      } = await axios.get('content/listactivepolling', { params })
      this.listPolling = data
    },
    showthecard () {
      this.showCard = !this.showCard
      this.$store.commit('setCardIsShow', this.showCard)
    },
    async getMemberBenefit () {
      const res = await axios.get('member/member/benefits')
      this.benefit = res?.data?.data
    },
    isMobileScreenSize () {
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.screen.width < 450
      )
    },
    seeAllAgenda () {
      window.open(process.env.VUE_APP_BACK_HOME_URL + 'agenda')
    },
    async downloadCard () {
      this.isDownloading = true
      // add class
      const elementCard = document.getElementById('cardMember')
      elementCard.classList.add('to-download')
      await setTimeout(1000)
      this.logger('after wait timeout')
      const scale = 3
      if (this.download_count === 0) {
        domtoimage.toPng(elementCard, {
          quality: 1,
          width: elementCard.clientWidth * scale,
          height: elementCard.clientHeight * scale,
          style: {
            transform: 'scale(' + scale + ')',
            transformOrigin: 'top left',
            opacity: 1
          }
        })
      }
      domtoimage
        .toPng(elementCard, {
          quality: 1,
          width: elementCard.clientWidth * scale,
          height: elementCard.clientHeight * scale,
          cacheBusta: true,
          style: {
            transform: 'scale(' + scale + ')',
            transformOrigin: 'top left',
            opacity: 1
          }
        })
        .then(dataUrl => {
          this.logger(dataUrl)
          var link = document.createElement('a')
          link.download = `kartu-anggota-${this.$store.state.profile.nama_lengkap}.jpg`
          link.href = dataUrl
          link.click()
          elementCard.classList.remove('to-download')
          this.download_count += 1
          this.isDownloading = false
          // removeclass
        })
        .catch(err => {
          this.logger(err)
          this.isDownloading = false
        })
    },
    directDownload () {
      this.showDownload = true
      setTimeout(() => {
        this.downloadCard()
        this.showDownload = false
      }, 200)
    },
    async getTodayEvent (date) {
      this.showDefaultEvent = true
      this.isEventLoading = true
      this.todayEvent = []
      const selected = `${date.getFullYear()}-${
        date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      }-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`
      try {
        const {
          data: { data }
        } = await axios.get('content/listeventbydate', {
          params: {
            limit: 10,
            page: 1,
            date_filter: selected
          }
        })
        this.todayEvent = data
        this.isEventLoading = false
      } catch {
        this.isEventLoading = false
      }
    },
    async getEventClicked (data) {
      this.listEvent = [data]
      this.showDefaultEvent = false
    }
  }
}
</script>
